import {I18n} from 'aws-amplify/utils';
import {
    Text,
    Tooltip,
} from '@mantine/core';

import {DnsZone} from '../types';

// ⚠️ AN EMPTY `nameservers` ON THE LIST IS "NOT LOADED", NOT "NONE" (FNP-1289).
//
// This is the same tri-state discipline as DelegationBadge next door, applied
// to a field whose third state is invisible in the type: `nameservers` is
// `[String!]!`, so an empty array is structurally identical to a real answer of
// zero, and only the CALL PATH tells them apart.
//
// The list path genuinely cannot know. Route 53's `ListHostedZones` does not
// return a zone's delegation set at all — only `GetHostedZone` does — so
// flexi-domains-route53-adapter's `listZones` passes `undefined` for
// nameservers by construction and every zone arrives on this screen with an
// empty array. Fetching the set per row would turn one provider call into N
// against a rate-limited API, on the first screen of the module, to fill a
// column nobody sorts by, so the adapter does not, and neither does this.
//
// Rendering `0` there asserts "this zone publishes no nameservers" — alarming,
// and false for all three zones in the estate. The contract says so in as many
// words: "empty means 'not yet assigned' rather than 'publishes none'. A caller
// that shows nameservers should say so rather than rendering a blank list as
// fact." The count is on the detail page, which reads the delegation set for
// real.
//
// Its own file because a module that also exports a hook or a constant breaks
// Fast Refresh, and this lints at --max-warnings 0.
export const NameserverCount = ({zone}: { zone: DnsZone }) => {

    const count = zone.nameservers?.length ?? 0;

    if (count === 0) {
        return (
            <Tooltip
                label={I18n.get('Nameservers are not read when listing zones. Open the zone to see the ones it publishes.')}
                withArrow={true}
            >
                <Text size={'sm'} c={'dimmed'}>—</Text>
            </Tooltip>
        );
    }

    return <Text size={'sm'}>{count}</Text>;
};
